import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import { useAtomValue } from 'jotai'
import { FC } from 'react'
import { FlexColumn } from 'src/components/flex-containers'
import { Colors } from 'src/components/theme'
import { formatString } from 'src/utils/format-string'
import { ParcelMap } from 'src/v2/components/parcel-map'
import * as sidebarAtoms from 'src/v2/state/owner-reveal/sidebar'

const Container = styled(FlexColumn)`
  align-items: center;
  justify-content: center;
  padding: 0 16px;
`

const Info = styled(FlexColumn)`
  align-items: center;
  justify-content: center;
`

export const PropertyRecordsParcelContent: FC = () => {
  const parcel = useAtomValue(sidebarAtoms.selectedParcel)

  if (!parcel) {
    return null
  }

  return (
    <Container gap={16}>
      <ParcelMap height={448} geometry={parcel?.geometry} defaultColor={Colors.primaryGreen700} />
      <Info gap={4}>
        <Typography
          variant="textmdm"
          color={Colors.textDark}>{`At ${formatString(parcel.address, 'address')}`}</Typography>
        <Typography
          variant="textmd"
          color={Colors.textDark}>{`Assessor's Parcel Number (APN) — ${parcel.apn}`}</Typography>
      </Info>
    </Container>
  )
}
